// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--H1Mom","tab":"tab--yN7eV","active":"active--FGXW6","buttonBulkMedia":"buttonBulkMedia--DEvfr"};